import { FormGroup, FormControl } from '@angular/forms';
import { BaseComponent } from './base.component';

export class ItemStructureBase extends BaseComponent {

    constructor() {
        super();
    }
}
